module.exports = __webpack_public_path__ + "img/option-default.2f68cf1d.svg";